module.exports = __webpack_public_path__ + "img/builder-21.99e331cc.webp";